import { REST_ROUTES } from '@cdw-ae/routes-shared-api';
import { ROUTE_PARAMS } from '../route-params';

/**
 * OU Collections controller route constants
 *
 * Maps to @Controller('ou-collections')
 */
export const OU_COLLECTIONS_ROUTES = {
  // Standard REST routes
  ROOT: REST_ROUTES.ROOT,
  GET_BY_ID: REST_ROUTES.GET_BY_ID,
  CAN_DELETE: `${ROUTE_PARAMS.ID}/can-delete`,

  // Nested resource routes
  ADD_ORG_UNITS: `${ROUTE_PARAMS.ID}/org-units`,
  REMOVE_ORG_UNIT: `${ROUTE_PARAMS.ID}/org-units/${ROUTE_PARAMS.OU_ID}`,

} as const;

/**
 * Type representing all possible OU collection routes
 */
export type OuCollectionsRoute =
  (typeof OU_COLLECTIONS_ROUTES)[keyof typeof OU_COLLECTIONS_ROUTES];
